var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowdownblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99955 10.9763L14.1244 6.85156L15.3029 8.03007L9.99955 13.3334L4.69629 8.03007L5.8748 6.85156L9.99955 10.9763Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowdownblue);
export default __webpack_public_path__ + "static/media/icon.arrow.down.blue.2de90dfad2a9f52142727c0119261f33.svg";
export { ForwardRef as ReactComponent };